import { apiClient } from "./client";

export type MannequinMetadata = {
  inputs: string[];
  outputs: string[];
  vehicles: string[];
  vehicle_labels: Record<string, string>;
  input_config: Record<string, {
    min: number;
    max: number;
    step: number;
    default: number;
    unit: string;
  }>;
  output_labels: Record<string, string>;
  output_config: Record<string, { min: number; max: number }>;
};

export type MannequinSurfaceRequest = {
  vehicle: string;
  seed: number;
  method: "spera" | "smooth";
  pathologies: "none" | "sampled";
  x_axis: string;
  y_axis: string;
  output: string;
  n: number;
  held: Record<string, number>;
};

export type MannequinFeature = {
  type: string;
  description?: string;
  params?: Record<string, unknown>;
  axes?: string[];
  manifold?: string;
  [key: string]: unknown;
};

export type MannequinOverlay = {
  name: string;
  mode: "lines" | "markers";
  x: number[];
  y: number[];
  z: number[];
  line?: { color?: string; width?: number; dash?: string };
  marker?: { color?: string; size?: number; symbol?: string };
};

export type MannequinOutputSurface = {
  z: number[][];
  z_range: [number, number];
  stats: { min: number; mean: number; max: number };
  overlays: MannequinOverlay[];
};

export type MannequinSurfaceResponse = {
  vehicle: string;
  seed: number;
  method: string;
  pathologies: string;
  x_axis: string;
  y_axis: string;
  output: string;
  outputs: string[];
  n: number;
  x: number[][];
  y: number[][];
  z: number[][];
  x_values: number[];
  y_values: number[];
  x_range: [number, number];
  y_range: [number, number];
  z_range: [number, number];
  features: MannequinFeature[];
  overlays: MannequinOverlay[];
  output_surfaces: Record<string, MannequinOutputSurface>;
  held: Record<string, number>;
  held_summary: string;
};

export function getMannequinMetadata(): Promise<MannequinMetadata> {
  return apiClient<MannequinMetadata>("/mannequin/metadata");
}

export function getMannequinSurface(
  request: MannequinSurfaceRequest,
): Promise<MannequinSurfaceResponse> {
  return apiClient<MannequinSurfaceResponse>("/mannequin/surface", {
    method: "POST",
    body: request,
  });
}
